import { render, staticRenderFns } from "./AddressFormGroup.vue?vue&type=template&id=515b4696"
import script from "./AddressFormGroup.vue?vue&type=script&lang=ts"
export * from "./AddressFormGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports